export const awsAuthConfig = {
    Auth: {
        Cognito: {
            userPoolId: process.env.REACT_APP_USERPOOLID,
            userPoolClientId: process.env.REACT_APP_USERPOOLWEBCLIENTID,
            allowGuestAccess: false,
            signUpVerificationMethod: 'link'
        }
    }
};
